import type { SessionStepModule } from '../types';
import { MsmeDetail } from './MsmeDetail';
import { MsmeStepRunner } from './MsmeStepRunner';
import { isMsmeStep } from './msme.utils';

// MSME Verification (Udyam) step module (Udyam verification without OTP, Protean).
export const msmeStepModule: SessionStepModule = {
  key: 'msme',
  matches: isMsmeStep,
  Runner: MsmeStepRunner,
  Detail: MsmeDetail,
};
